export const VIEW_LISTING = "VIEW_LISTING";
export const VIEW_KANBAN = "VIEW_KANBAN";
export const VIEW_SPLIT = "VIEW_SPLIT";
export const DENSITY_DEFAULT = "default";
export const DENSITY_COMFORTABLE = "comfortable";
export const DENSITY_COMPACT = "compact";
export const SUPER_ADMIN_SLUG = "super_admin";
export const WIDGET_DEFAULT_COLOR = "#084298";
export const WIDGET_DEFAULT_STYLE = "bubble";
export const WIDGET_DEFAULT_POSITION = "right";
export const DEFAULT_VISITOR_IDLE_STATE_TIME = 30; // minutes
export const signedUrlExpireSeconds = 60 * 60 * 24;
export const Package = "Package";
export const Coupon = "Coupon";
export const Voucher = "Voucher";

export const Properties = "Properties";
export const Reports = "Reports";
export const Users = "Users";

export const passwordRegex =
  /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]{6,}$/;
export const regexLength = /.{6,}/;
export const regexNumber = /\d/;
export const regexSpecialChar = /[!@#$%^&*._-]/;
export const regexUpperLower = /^(?=.*[a-z])(?=.*[A-Z])/;
export const MESSAGE_TYPES = {
  chat: 0,
  navigation: 1,
  activity: 2,
  attachment: 3,
  log: 4,
};

export const Visitor_status = {
  inactive: 0,
  active: 1,
  idle: 2,
};

export const chat_status = {
  no_action: 0,
  started: 1,
  ended: 2,
};

export const Visitor_status_text = {
  [Visitor_status.inactive]: "Inactive",
  [Visitor_status.active]: "Active",
  [Visitor_status.idle]: "Idle",
};

export const Collections = {
  tokens: "fcmTokens",
  companies: "companies",
  visitors: "visitors",
  activities: "activities",
  deviceTokens: "fcmTokens",
  sessions: "sessions",
  users: "users",
  invitedMembers: "invitedMembers",
  properties: "properties",
  propertyMembers: "propertyMembers",
  invitedPropertyMembers: "invitedPropertyMembers",
  widgets: "widgets",
  shortcuts: "shortcuts",
  roles: "roles",
  reports: "reports",
  histories: "histories",
  banList: "banList",
  departments: "departments",
  allShortcuts: "allShortcuts",
  contacts: "contacts",
  feedbacks: "feedbacks",
  triggers: "triggers",
  packages: "packages",
  subscriptions: "subscriptions",
  price: "packagePrice",
  refunds: "refunds",
  invoices: "invoices",
  coupons: "coupons",
  vouchers: "vouchers",
};

export const Packages_Form = {
  package_name: {
    name: "name",
    label: "Package Name",
    rules: [{ required: true, message: "Please enter Package Name" }],
    placeholder: "Please enter Package Name",
  },

  slug: {
    name: "slug",
    label: "Package Slug",
    rules: [{ required: true, message: "Please enter Package Slug" }],
    placeholder: "Package Slug will be auto generated",
  },
  package_price: {
    name: "price",
    label: "Package Price",
    rules: [{ required: true, message: "Please enter Package Price" }],
    placeholder: "Please enter Package Price",
  },
  product_id: {
    name: "product_id",
    label: "Product Id",
    rules: [{ required: true, message: "Please enter Product Id" }],
    placeholder: "Please enter Product Id",
  },

  monthlyCostOfYearlyPlan: {
    name: "monthlyCostOfYearlyPlan",
    label: "Monthly Cost of Yearly Plan Per Agent",
    rules: [
      { required: true, message: "Please enter Monthly Cost of Yearly Plan" },
    ],
    placeholder: "Monthly Cost of Yearly Plan",
  },

  monthlyCostOfMonthlyPlan: {
    name: "monthlyCostOfMonthlyPlan",
    label: "Monthly Cost of Monthly Plan Per Agent",
    rules: [
      { required: true, message: "Please enter Monthly Cost of Monthly Plan" },
    ],
    placeholder: "Monthly Cost of Monthly Plan",
  },

  oneTimeProductCost: {
    name: "oneTimeProductCost",
    label: "One Time Product Cost",
    placeholder: "One Time Product Cost",
  },
  price_id: {
    name: "price_id",
    label: "Price Id",
    placeholder: "Please enter Price Id",
  },
  short_description: {
    name: "short_description",
    label: "Tag Line",
    placeholder: "Please enter Tag Line of product",
  },
  trial_days: {
    name: "trial_days",
    label: "Trial days",
    placeholder: "Please enter Trial days in number",
  },
  user_limit: {
    name: "user_limit",
    label: "User Creation Limit",
    placeholder: "Please enter User  Creation Limit in number",
  },

  history_days: {
    name: "history_days",
    label: "Visitor History Days",
    rules: [
      { required: true, message: "Please enter Visitor History Days Limit" },
    ],
    placeholder: "Visitor History Days Limit",
  },

  remove_branding: {
    name: "remove_branding",
    label: "Remove Branding",
    placeholder: "Please Select Remove Branding",
  },
};

export const Packages_Price_Form = {
  package_id: {
    name: "package_id",
    label: "Package",
    rules: [{ required: true, message: "Please select Package " }],
    placeholder: "Please selct Package ",
  },

  package_name: {
    name: "package_name",
    label: "Package Name",
    rules: [{ required: true, message: "Please select Package name " }],
    placeholder: "Please enter Package Name",
  },

  package_price_name: {
    name: "package_price_name",
    label: "Package Price Name",
    rules: [{ required: true, message: "Please enter Package Price Name" }],
    placeholder: "Please enter Package Price Name",
  },

  regular_price: {
    name: "regular_price",
    label: "Regular Price",
    rules: [{ required: true, message: "Please enter Package Price" }],
    placeholder: "Please enter Package Price",
  },

  sale_price: {
    name: "sale_price",
    label: "Sale Price",
    rules: [{ required: true, message: "Please enter Package Price" }],
    placeholder: "Please enter Package Price",
  },
  product_id: {
    name: "product_id",
    label: "Product Id",
    rules: [{ required: true, message: "Please enter Product Id" }],
    placeholder: "Please enter Product Id",
  },

  stripe_price_id: {
    name: "stripe_price_id",
    label: "Stripe Price Id",
    rules: [{ required: true, message: "Please enter Stripe Price Id" }],
    placeholder: "Please enter Stripe Price Id",
  },

  price_type: {
    name: "price_type",
    label: "Price Type",
    placeholder: "Please select Price Type",
  },

  recurring_interval: {
    name: "recurring_interval",
    label: "Recurring Interval",
    placeholder: "Please select Recurring Interval",
  },

  status: {
    name: "status",
    label: "Status",
    placeholder: "Please select status",
  },
  description: {
    name: "description",
    label: "Description",
    placeholder: "Please enter Descriptiont",
  },
  trial_days: {
    name: "trial_days",
    label: "Trial days",
    placeholder: "Please enter Trial days in number",
  },
};

export const Coupon_Form = {
  price_id: {
    name: "price_ids",
    label: "Package Price Id",
    rules: [{ required: true, message: "Please select Price Ids" }],
    placeholder: "Select Package Price Ids",
  },

  coupon_name: {
    name: "coupon_name",
    label: "Coupon Name",
    rules: [{ required: true, message: "Please enter Coupon name " }],
    placeholder: "Please Coupon Name",
  },

  coupon_code: {
    name: "coupon_code",
    label: "Coupon Code",
    rules: [{ required: true, message: "Please enter Coupon code " }],
    placeholder: "Please enter Coupon Code",
  },

  description: {
    name: "description",
    label: "Description",
    placeholder: "Please enter Description",
  },

  stripe_promo_id: {
    name: "stripe_promo_id",
    label: "Stripe Promo Id",
    rules: [{ required: true, message: "Please enter stripe code " }],
    placeholder: "Please enter Stripe Promo id",
  },

  discount_type: {
    name: "discount_type",
    label: "Discount Type",
    options: [
      { label: "Percentage", value: "percentage" },
      { label: "Fixed Amount", value: "fixed" },
    ],
    rules: [{ required: true, message: "Please select Discount Type " }],
    placeholder: "Select an option",
  },

  discount: {
    name: "discount",
    label: "Discount",
    rules: [{ required: true, message: "Please enter discount " }],
    placeholder: "Please enter discount",
  },

  expired_at: {
    name: "expired_at",
    label: "Expired At",
    rules: [{ required: true, message: "Please enter Expiry " }],
    placeholder: "Please select Expiry date",
  },

  usage_per_coupon: {
    name: "usage_per_coupon",
    label: "Usage per coupon",
    rules: [{ required: true, message: "Please enter Usage per coupon " }],
    placeholder: "How many times coupon can be used",
  },

  usage_per_user: {
    name: "usage_per_user",
    label: "Usage limit per user",
    rules: [{ required: true, message: "Please enter Usage per user " }],
    placeholder:
      "How many times this coupon can be used by an individual user. Uses billing email for guests, and user ID for logged in users.",
  },

  status: {
    name: "status",
    label: "Status",
    options: [
      { label: "Active", value: "active" },
      { label: "Inactive", value: "inactive" },
    ],
    defaultValue: "active",
    rules: [{ required: true, message: "Please select status " }],
    placeholder: "Select an option",
  },
};

export const Voucher_Form = {
  price_id: {
    name: "price_id",
    label: "Package Price ",
    rules: [{ required: true, message: "Please select Price Id" }],
    placeholder: "Select Package Price Id",
  },
  package_price_name: {
    name: "package_price_name",
    label: "Package Price ",
    placeholder: "Please  enter Package Price Name",
  },

  voucher_code: {
    name: "voucher_code",
    label: "Voucher Code",
    rules: [{ required: true, message: "Please enter voucher code " }],
    placeholder: "Please enter voucher Code",
  },

  expires_at: {
    name: "expires_at",
    label: "Expires At",
    rules: [{ required: true, message: "Please enter Expiry " }],
    placeholder: "Please select Expiry date",
  },

  vendor: {
    name: "vendor",
    label: "Vendor",
    rules: [{ required: true, message: "Please select Vendor" }],
    placeholder: "Select Package Vendor",
  },
};

export const preChatDefaultForm = [
  {
    isDefault: true,
    type: "text-field",
    required: true,
    show: true,
    options: [],
    name: "name",
    label: "Name",
    placeholder: "Enter your name",
  },
  {
    isDefault: true,
    type: "text-field",
    required: true,
    show: true,
    options: [],
    name: "email",
    label: "Email",
    placeholder: "Enter your email",
  },
  {
    isDefault: true,
    type: "text-field",
    required: true,
    show: true,
    options: [],
    name: "phone",
    label: "Phone",
    placeholder: "Enter your phone",
  },
  {
    isDefault: true,
    type: "text-area",
    required: false,
    show: true,
    options: [],
    name: "message",
    label: "Message",
    placeholder: "Enter your message",
  },
];

export const vouchers_venders = [
  "stacksocial",
  "appsumo",
  "dealfuel",
  "dealmirror",
  "BitsjuDour",
  "MightyDeals",
  "WowCher",
  "GroupOn",
  "BundleHunt",
];

export const SidebarItems = [
  { key: "/reports", label: "Reports" },
  { key: "/properties", label: "Properties" },
  { key: "/users", label: "Users" },
  { key: "/chat-history", label: "Chat History" },

  { key: "/packages", label: "Packages" },
  { key: "/prices", label: "Package Price" },
  { key: "/coupons", label: "Coupons" },
  { key: "/vouchers", label: "Vouchers" },
  { key: "/subscriptions", label: "Subscriptions" },
  { key: "/invoices", label: "Invoices" },
  { key: "/refunds", label: "Refunds" },
];

export const WIDGET_URL = process.env.REACT_APP_WIDGET_URL;
